import { CoverLetter, Resume } from 'packages/types'

export type Primitive = string | number | boolean | null

export enum MODES {
  editor = 'editor',
  wizard = 'wizard',
}

export type CurrentDocument = Resume | CoverLetter

export type PreviewRefProps = {
  reset: () => void
  previousPage: () => void
  nextPage: () => void
  resize: (width: number) => void
}
